/* eslint-disable react/prop-types */

import { useState } from "react";
import { InlineEditIcon } from "../icons";
import { pipe } from "../../utils/helpers";
import toUSString from "../../utils/Currency";
import Switcher from "./Switcher";
import TextInput from "../../../shared/v2/TextInput";

const ignoreNaN = (valueString) => (valueString === "$NaN" ? "" : valueString);
const adjustSeparator = (valueString) => valueString.replace(/,/g, "");
const numberify = (valueString) => Math.round(parseFloat(valueString));
const format = (value) => pipe(adjustSeparator, numberify, toUSString, ignoreNaN)(value);

const CurrencyCell = ({ value, isEditable, onChange, onActivate, justify }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState(value || "");

  const iconType = <InlineEditIcon isEditable={isEditable} />;
  const formattedValue = format(value || "");

  const blankNonEditableDisplay = <span>—</span>;
  const blankEditableDisplay = (
    <span data-cy="editable-blank-currency-cell" className="actionable tw-text-theme-text-button-color">
      Add
    </span>
  );
  const nonEditableDisplay = <span>{formattedValue}</span>;
  const editableDisplay = (
    <div data-cy="editable-display-currency-cell">
      <span className="actionable tw-mr-8px">{formattedValue}</span>
      {iconType}
    </div>
  );
  const isEmpty = !currentValue || currentValue.length === 0;

  const maybeToggleToInput = () => {
    if (!isEditing && isEditable) {
      if (onActivate) {
        onActivate();
      } else {
        setIsEditing(true);
      }
    }
  };

  const updateIfChanged = (newValue) => {
    if (newValue !== value) onChange(newValue);
  };

  const handlekeydownEvent = (event) => {
    const { keyCode } = event;
    if (keyCode === 13) {
      updateIfChanged(event.target.value);
      setIsEditing(false);
    }
  };

  const input = (
    <TextInput
      data-cy="editable-input-currency-cell"
      value={currentValue}
      style={{ maxWidth: "10em" }}
      ref={(newInput) => newInput && newInput.focus()}
      onChange={(e) => setCurrentValue(e.target.value)}
      onKeyDown={handlekeydownEvent}
      onBlur={(e) => {
        updateIfChanged(e.target.value);
        setIsEditing(false);
      }}
    />
  );

  let content = null;
  if (!isEditable && !isEmpty) {
    content = nonEditableDisplay;
  } else if (!isEditable && isEmpty) {
    content = blankNonEditableDisplay;
  } else if (isEditable && isEditing) {
    content = input;
  } else if (isEditable && !isEditing && isEmpty) {
    content = blankEditableDisplay;
  } else if (isEditable && !isEditing && !isEmpty) {
    content = editableDisplay;
  }

  return (
    <Switcher justify={justify} onClick={maybeToggleToInput} isActionable={isEditable && !isEditing}>
      {content}
    </Switcher>
  );
};

export default CurrencyCell;
